export const config = {
    URL: process.env.REACT_APP_API_URL ?? 'http://localhost:3001/apikomis/'
};